/**
 * author: Mig Magtoto
 * 
 * description: 
 *  Is called whenever there is a new event
 *  is called by PicturesPage and takes in three props
 *  - Cover, Link, and Event
 *  These are then displayed depending on the screen size
 */

import { Box, Typography } from "@mui/material";
import defaultImg from "./placeholderPics/default.png"
import gobImg from "./placeholderPics/gobblerfest2.jpg";
import picImg from "./placeholderPics/picnic.JPG";
import firstgbmImg from "./placeholderPics/firstgbm.jpg"
import atekuyaImg from "./placeholderPics/atekuyaim.JPG"
import revealImg from "./placeholderPics/reveal.jpg"
import bonImg from "./placeholderPics/bonfire.jpg"
import deetImg from "./placeholderPics/deet.jpg"
import gameImg from "./placeholderPics/game.jpg"
import d7pracImg from "./placeholderPics/d7prac.jpg"
import fahmImg from "./placeholderPics/fahm.jpg"



const GalleryComponent = (props) => {
    const name = props.event?.toLowerCase() || "";

    // hard coding of thumbnail images
    let imageSrc = defaultImg; // default placeholder
    if (name.startsWith("gob")) {
        imageSrc = gobImg;
    }
    else if (name.startsWith("wel")) {
        imageSrc = picImg;
    }
    else if (name.startsWith("fir")) {
        imageSrc = firstgbmImg;
    }
    else if (name.startsWith("ate/")){
        imageSrc = atekuyaImg;
    }
    else if (name.startsWith("reveal")){
        imageSrc = revealImg;
    }
    else if (name.startsWith("bonfire")){
        imageSrc = bonImg;
    }
    else if (name.startsWith("deet")){
        imageSrc = deetImg;
    }
    else if (name.startsWith("game")){
        imageSrc = gameImg;
    }
    else if (name.startsWith("d7 practice")){
        imageSrc = d7pracImg;
    }
    else if (name.startsWith("fahm")){
        imageSrc = fahmImg;
    }
  return (
    <Box
      component="a"
      href={props.link}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        textDecoration: "none",
        display: "block",
        bgcolor: "background.paper",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
      }}
    >
      {/* Every thumbnail is pinned to 3:2 so the tiles line up. Most of the
          photos are already that shape; anything else is cropped to fill. */}
      <Box
        component="img"
        src={imageSrc}
        alt={props.event}
        loading="lazy"
        sx={{
          width: "100%",
          aspectRatio: "3 / 2",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Typography variant="h6" sx={{ px: "16px", py: "14px", color: "primary.main" }}>
        {props.event}
      </Typography>
    </Box>
  );
};

export default GalleryComponent;
